// Eligibility API returns lowercase provider names — see
// Tenant/Domain/Payroll/Provider/PayrollPartnerSystemResolver::resolveForTenant
const AU_PROVIDERS: ReadonlyArray<string> = ['microkeeper', 'microkeeperbeta'];
const US_PROVIDERS: ReadonlyArray<string> = ['paycor'];
const UK_PROVIDERS: ReadonlyArray<string> = ['iris'];

export function isAUProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return AU_PROVIDERS.includes(provider.toLowerCase());
}

export function isUSProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return US_PROVIDERS.includes(provider.toLowerCase());
}

export function isUKProvider(provider: string | undefined): boolean {
  if (!provider) {
    return false;
  }
  return UK_PROVIDERS.includes(provider.toLowerCase());
}
